import { useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import BreathingSession from '@/pages/BreathingSession';
import PatternEditor from '@/pages/PatternEditor';
import SessionHistory from '@/pages/SessionHistory';
import AdminPanel from '@/pages/AdminPanel';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/session/:patternId" element={<BreathingSession />} />
              <Route path="/create-pattern" element={<PatternEditor />} />
              <Route path="/edit-pattern/:patternId" element={<PatternEditor />} />
              <Route path="/history" element={<SessionHistory />} />
              <Route path="/admin" element={<AdminPanel />} />
            </Routes>
          </Layout>
          <Toaster position="top-center" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;